import uniqueId from 'lodash/uniqueId';

const makeUnique = (svg) => {
  const prefix = `${uniqueId()}-`;
  let output = svg;

  output = output.replace(/ id="/g, ` id="${prefix}`);
  output = output.replace(/url\(#/g, `url(#${prefix}`);

  return output;
};

export const edit = document.querySelector('[data-template="icon-edit"]').innerHTML;
export const heart = document.querySelector('[data-template="icon-heart"]').innerHTML;
export const heartFilled = document.querySelector('[data-template="icon-heart-filled"]').innerHTML;
export const remove = document.querySelector('[data-template="icon-remove"]').innerHTML;
export const cartPlus = document.querySelector('[data-template="icon-cart-plus"]').innerHTML;
export const cartMinus = document.querySelector('[data-template="icon-cart-minus"]').innerHTML;
export const flagDK = () =>
  makeUnique(document.querySelector('[data-template="icon-flag-dk"]').innerHTML);
export const flagGB = () =>
  makeUnique(document.querySelector('[data-template="icon-flag-gb"]').innerHTML);
export const flagDE = () =>
  makeUnique(document.querySelector('[data-template="icon-flag-de"]').innerHTML);
export const flagNO = () =>
  makeUnique(document.querySelector('[data-template="icon-flag-no"]').innerHTML);
export const flagSE = () =>
  makeUnique(document.querySelector('[data-template="icon-flag-se"]').innerHTML);
export const flagUS = () =>
  makeUnique(document.querySelector('[data-template="icon-flag-us"]').innerHTML);

export default {
  edit,
  heart,
  heartFilled,
  remove,
  cartPlus,
  cartMinus,
  flagDK,
  flagGB,
  flagDE,
  flagNO,
  flagSE,
  flagUS,
};
